export const PROSPECT_TYPE_LABEL = "Potential seller";
export const MLS_FALLBACK_LABEL = "MLS listing";

const spaced = (value) =>
  String(value)
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/\s+/g, " ")
    .trim();

export const mlsTypeLabel = (item) => {
  const raw = item?.PropertySubType || item?.PropertyType;
  return raw ? spaced(raw) : MLS_FALLBACK_LABEL;
};

export const typeLabel = (item) =>
  item?.rowType === "mls" ? mlsTypeLabel(item) : PROSPECT_TYPE_LABEL;

export const mlsAddressLine = (item) => {
  const street = (item?.Location || "").trim();
  if (!street || street.includes(",")) return street;
  const cityState = [item?.City, item?.State].filter(Boolean).join(", ");
  const tail = [cityState, item?.ZIP].filter(Boolean).join(" ");
  return tail ? `${street}, ${tail}` : street;
};
